module.exports = __webpack_public_path__ + "static/assets/ee58700bbc60f4befb8ae33dbcb0bc58.svg";